// extracted by mini-css-extract-plugin
module.exports = {"modal_center":"PheDuyetModal_modal_center__2vSlT","tool_bar":"PheDuyetModal_tool_bar__3Nh1S","text":"PheDuyetModal_text___5dsA"};